import { createFileRoute } from "@tanstack/react-router";
import ArticleAdsManager from "@/pages/admin/ArticleAdsManager";

export const Route = createFileRoute("/admin/article-ads")({
  component: ArticleAdsManager,
});
